module.exports = __webpack_public_path__ + "static/curved2.30d83844.svg";


//////////////////
// WEBPACK FOOTER
// ./src/img/curved2.svg
// module id = 231
// module chunks = 35783957827783 95715928098905 172322841747965